import { render, staticRenderFns } from "./ConsultaPendencia.vue?vue&type=template&id=0988fd1f"
import script from "./ConsultaPendencia.vue?vue&type=script&lang=js"
export * from "./ConsultaPendencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports